<ng-container>
  <div class="campaign-table-status__bullet" [ngClass]="'campaign-table-status__bullet--' + campaign?.status"></div>
  {{ getStatus() }}
</ng-container>
